var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhysicalassets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Physical assets",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke",
    d: "M18 14.5V2.11C18 1.5 17.47 1 16.81 1H3.18C2.53 1 2 1.5 2 2.11V19.9C2 20.5 2.53 21 3.18 21H13",
    stroke: "#605E5C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.67 5.48c0 .23-.1.42-.2.42H4.2c-.11 0-.2-.19-.2-.42 0-.24.09-.43.2-.43h6.27c.1 0 .2.2.2.43ZM10.67 7.71c0 .23-.1.42-.2.42H4.2c-.11 0-.2-.19-.2-.42 0-.23.09-.43.2-.43h6.27c.1 0 .2.2.2.43ZM10.67 9.83c0 .24-.1.43-.2.43H4.2c-.11 0-.2-.2-.2-.43 0-.23.09-.42.2-.42h6.27c.1 0 .2.19.2.42ZM10.67 12.07c0 .23-.1.42-.2.42H4.2c-.11 0-.2-.19-.2-.42 0-.24.09-.43.2-.43h6.27c.1 0 .2.2.2.43ZM10.67 14.43c0 .23-.1.42-.2.42H4.2c-.11 0-.2-.19-.2-.42 0-.24.09-.43.2-.43h6.27c.1 0 .2.2.2.43Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 4,
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v4M19 19h-4",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2 4.1-1.18 1.18-.4-.4a.36.36 0 0 0-.51.51l.65.66a.36.36 0 0 0 .52 0l1.43-1.43a.36.36 0 0 0-.12-.6.36.36 0 0 0-.4.09ZM15.2 8.1l-1.18 1.18-.4-.4a.36.36 0 0 0-.51.51l.65.66a.36.36 0 0 0 .52 0l1.43-1.43a.36.36 0 0 0-.12-.6.36.36 0 0 0-.4.09ZM15.2 13.1l-1.18 1.18-.4-.4a.36.36 0 0 0-.51 0 .36.36 0 0 0 0 .51l.65.66a.36.36 0 0 0 .52 0l1.43-1.43a.36.36 0 0 0 0-.51.36.36 0 0 0-.51 0Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalassets);
export default __webpack_public_path__ + "static/media/Physical assets.6ebe854608e5c25c5a7b65a2f7ac0308.svg";
export { ForwardRef as ReactComponent };